import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const DealCheckAvailabilityAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "deal-check-availability" */ './deal-check-availability'),
  componentName: 'DealCheckAvailability',
});
